import { useCallback, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { debounce } from '@cian/ui-kit/internal/utils';
import { setCreditTerm, setFlatPrice } from '../../../redux';
import { selectCalculatorValues } from '../../../selectors/selectCalculatorValues';
import { useEventOnCalculateSubsidizedMortgage } from 'shared/subsidizedCalculator/hooks/useEventOnCalculateSubsidizedMortgage';

export const useSliderInputs = () => {
  const dispatch = useDispatch();
  const eventRef = useRef<HTMLDivElement | null>(null);
  const calculatorState = useSelector(selectCalculatorValues);
  const [priceSliderValue, setPriceSliderValue] = useState<number>(calculatorState.price);
  const [termSliderValue, setTermSliderValue] = useState<number>(calculatorState.term);

  const debouncedSetCreditTermHandler = useCallback(
    debounce(val => dispatch(setCreditTerm(val)), 100),
    [],
  );

  const debouncedSetFlatPriceHandler = useCallback(
    debounce(val => dispatch(setFlatPrice(val)), 100),
    [],
  );

  useEventOnCalculateSubsidizedMortgage(eventRef);

  const handleChangePrice = (value: number) => {
    setPriceSliderValue(value);
    debouncedSetFlatPriceHandler(value);
  };

  const handleChangeLoanTerm = (value: number) => {
    setTermSliderValue(value);
    debouncedSetCreditTermHandler(value);
  };

  return {
    eventRef,
    priceSliderValue,
    termSliderValue,
    handleChangePrice,
    handleChangeLoanTerm,
    calculatorState,
  };
};
